import { useEffect, useRef } from "react";

export function useAutoRefresh(fn, ms = 20000, enabled = true) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    if (!enabled) return undefined;
    const run = () => { if (document.visibilityState === "visible") ref.current(); };
    const id = setInterval(run, ms);
    window.addEventListener("focus", run);
    document.addEventListener("visibilitychange", run);
    return () => {
      clearInterval(id);
      window.removeEventListener("focus", run);
      document.removeEventListener("visibilitychange", run);
    };
  }, [ms, enabled]);
}
